<template>
    <div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/admin/profile-settings">Home</router-link></li>
									<li class="breadcrumb-item active"><router-link to="/siswa/learndoteach">LearnDoTeach</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">{{ldt.nama_paket}} > {{ldt.judul_pertemuan}}</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">{{ldt.nama_paket}} > {{ldt.judul_pertemuan}}</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
				
				<div class="custom-container">
					<div class="row">
					
						<!-- Profile Sidebar -->
						<!-- <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                                <Sidebar />
						</div> -->
						<!-- /Profile Sidebar -->
						
                        
						<div class="col-md-12 col-lg-12 col-xl-12 dct-appoinment">
							<!-- <div class="card"> -->
                                <div class="row">
                                    <div class="col-md-7 col-lg-8">
                                        <div class="card">
                                             <div class="card-header">
                                                <div class="login-header">
                                                    <h3>Soal Nomor {{idxSoal}}
                                                        <!-- <button class="btn btn-rounded float-right" :class="{'btn-outline-danger': !soal.ket_laporan, 'btn-outline-warning': soal.ket_laporan}" @click="getLaporan()"><i class="fa fa-info-circle"></i> {{soal.ket_laporan ? "Soal Sudah dilaporkan":"Laporkan Soal"}} </button> -->
                                                    </h3>
                                                </div>
                                            </div>
                                            <!-- Checkout Form -->
                                            <form>
                                                <div class="card-body" v-if="!lstsoal.length" style="min-height:300px">
                                                    <p class="alert-info">Soal Belum tersedia, silahkan klik tambah soal</p>
                                                </div>
                                                <div class="card-body" v-if="lstsoal.length">
                                                    <!-- Personal Information -->
                                                    <div class="info-widget">
                                                        <h4 class="card-title">Uraian Soal</h4>
                                                        <div class="row">
                                                            <!-- <div class="col-md-6 col-sm-12">
                                                                <div class="form-group card-label">
                                                                    <label>First Name</label>
                                                                    <input class="form-control" type="text">
                                                                </div>
                                                            </div>
                                                            <div class="col-md-6 col-sm-12">
                                                                <div class="form-group card-label">
                                                                    <label>Last Name</label>
                                                                    <input class="form-control" type="text">
                                                                </div>
                                                            </div>
                                                            <div class="col-md-6 col-sm-12">
                                                                <div class="form-group card-label">
                                                                    <label>Email</label>
                                                                    <input class="form-control" type="email">
                                                                </div>
                                                            </div>
                                                            <div class="col-md-6 col-sm-12">
                                                                <div class="form-group card-label">
                                                                    <label>Phone</label>
                                                                    <input class="form-control" type="text">
                                                                </div>
                                                            </div> -->
                                                            <div class="col-md-12 col-sm-12">
                                                                <!-- <div class="form-group card-label"> -->
                                                                    
                                                                    <input name=image type=file id="upload" onchange="" class="hidden">
                                                                    <tinymce
                                                                        api-key="9fadqwhnobewr1vrn5r7wcwywh6g4acyftptdbl72sv99gnh"
                                                                        :init="myInit"
                                                                        v-model="soal.uraian_soal"
                                                                        @change="updIsSaveSoal"
                                                                        />
                                                                    <!-- <tinymce
                                                                        api-key="9fadqwhnobewr1vrn5r7wcwywh6g4acyftptdbl72sv99gnh"
                                                                        :init="{
                                                                            height: 300,
                                                                            entity_encoding : 'raw',
                                                                            plugins: [
                                                                            'lists link image paste help wordcount'
                                                                            ],
                                                                            toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help',
                                                                            
                                                                        }"
                                                                        v-model="soal.uraian_soal"
                                                                        @change="updIsSaveSoal"
                                                                        /> -->
                                                                        <!-- menubar: false,
                                                                            plugins: [
                                                                            'advlist autolink lists link image charmap print preview anchor',
                                                                            'searchreplace visualblocks code fullscreen',
                                                                            'insertdatetime media table paste code help wordcount'
                                                                            ],
                                                                            toolbar:
                                                                            'undo redo | formatselect | bold italic backcolor | \
                                                                            alignleft aligncenter alignright alignjustify | \
                                                                            bullist numlist outdent indent | removeformat | help' -->
                                                                <!-- </div> -->
                                                            </div>
                                                        </div>
                                                        <!-- <div class="exist-customer">Existing Customer? <a href="#">Click here to login</a></div> -->
                                                    </div>
                                                    <!-- /Personal Information -->
                                                    
                                                    <div class="info-widget">
                                                        <h4 class="card-title">Opsi Jawaban</h4>
                                                        <div class="card-body">    
                                                            <table style="width:100%" class="table table-borderless">
                                                                <!-- <tr v-for="index in 5" :key="index">
                                                                    <td><input class="payment-radio form-check-input" type="checkbox"></td>
                                                                    <td><input class="form-control" type="text" style="width:100%" :placeholder="'Opsi ke-' + index"></td>
                                                                </tr> -->
                                                                <tr v-for="(opsi) in this.list_jawaban" :key="opsi.id_jawaban">
                                                                    <td>{{opsi.jawaban}}</td>
                                                                    <td>
                                                                        <tinymce
                                                                        api-key="9fadqwhnobewr1vrn5r7wcwywh6g4acyftptdbl72sv99gnh"
                                                                        :init="myInitJawaban"
                                                                        v-model="opsi.uraian_jawaban"
                                                                        @change="updIsSaveSoal"
                                                                        />
                                                                        <!-- <input class="form-control" type="text" style="width:100%" v-model="opsi.uraian_jawaban" :placeholder="'Opsi ke-' + i" 
                                                                        @change="updIsSaveSoal"> -->
                                                                        </td>
                                                                    <td><div class="btn disabled" 
                                                                            :class="{'btn-outline-success' : opsi.poin == 5, 
                                                                                     'btn-outline-primary' : opsi.poin == 4, 
                                                                                     'btn-outline-danger' : opsi.poin == 3, 
                                                                                     'btn-outline-secondary' : opsi.poin == 2, 
                                                                                     'btn-outline-light' : opsi.poin == 1 || opsi.poin == 0, }">
                                                                        POIN : {{opsi.poin}}</div></td>
                                                                    <!-- <td><input class="payment-radio form-check-input" type="checkbox"></td> -->
                                                                </tr>
                                                                <!-- <tr>
                                                                    <td colspan="2">                                                  
                                                            <div class="form-group">
                                                                        <input type="text" class="form-control" v-model="soal.jawaban" style="width:100%">
                                                                    </td>
                                                                </tr> -->
                                                                <!-- <tr v-for="(opsi,i) in list_jawaban" :key="opsi.id_jawaban">
                                                                    <td><input class="payment-radio form-check-input" type="checkbox"></td>
                                                                    <td><input class="form-control" type="text" style="width:100%" v-model="list_jawaban[i].uraian_jawaban" :placeholder="'Opsi ke-' + i"></td>
                                                                </tr> -->
                                                            </table>

                                                                                            
                                                            <!-- <div class="form-group">
                                                                <label>Jawaban <span class="text-danger">*</span></label>
                                                                <input class="form-control" type="text" v-model="soal.jawaban" required>
                                                            </div> -->

                                                        </div>
                                                    </div>
                                                    <div class="info-widget">
                                                        <h4 class="card-title">Jawaban Benar</h4>
                                                        <div class="row">
                                                            <div class="col-md-12 col-sm-12">
                                                                <input class="form-control" type="text" v-model="soal.jawaban" @change="updatePoin" required>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="info-widget">
                                                        <h4 class="card-title">Pembahasan</h4>
                                                        <div class="row">
                                                            <div class="col-md-12 col-sm-12">
                                                                    <tinymce
                                                                        api-key="9fadqwhnobewr1vrn5r7wcwywh6g4acyftptdbl72sv99gnh"
                                                                        :init="myInit"
                                                                        v-model="soal.pembahasan"
                                                                        @change="updIsSaveSoal"
                                                                        />
                                                            </div>
                                                        </div>
                                                        
                                                    </div>
                                                
                                                </div>
                                                <div class="card-footer" v-if="lstsoal.length">
                                                    <!-- Submit Section -->
                                                    <div class="text-center">
                                                        <button type="button" @click.prevent="save" class="btn btn-primary">Simpan</button>
                                                        <button type="button" class="btn btn-danger"  data-toggle="modal" data-target="#delMdl">Hapus</button>
                                                    </div>
                                                    <!-- /Submit Section -->

                                                </div>
                                            
                                            </form>
                                            <!-- /Checkout Form -->
                                        </div>
                                        
                                    </div>
                                    
                                    <div class="col-md-5 col-lg-4 theiaStickySidebar">
                                    
                                        <!-- Booking Summary -->
                                        <div class="card booking-card">
                                            <div class="card-header">
                                                <!-- <h4 class="card-title">Booking Summary</h4> -->
                                                <!-- Booking Doctor Info -->
                                                <!-- <div class="booking-doc-info"> -->
                                                    <!-- <router-link to="/profile" class="booking-doc-img">
                                                        <img src="@/assets/img/schools/school-1.jpg" alt="User Image">
                                                    </router-link> -->
                                                    <div class="booking-info">
                                                        <h4><router-link to="/profile">{{ldt.judul_pertemuan}}</router-link></h4>
                                                        <div class="shop-details">
                                                            <p class="doc-location"><i class="fas fa-map-marker-alt"></i> {{ldt.nama_paket}}</p>
                                                        </div>
                                                        <div class="col-auto text-center float-center ml-auto">
                                                            <a href="#" class="btn btn-primary btn-sm" @click.prevent="addNewSoal">Tambah Soal</a>
                                                        </div>
                                                    </div>
                                                <!-- </div> -->
                                                <!-- Booking Doctor Info -->
                                                
                                            </div>
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-auto text-center float-right ml-auto">
                                                        <div class="btn-toolbar">
                                                            <div class="btn-group btn-group-sm">
                                                                <button class="btn btn-light" @click="setRowSoal(--index)" v-if="index > 0" > <i class="fas fa-arrow-left"></i>  </button>
                                                                <button class="btn btn-light" @click="setRowSoal(++index)" v-if="index < lstsoal.length - 1"> <i class="fas fa-arrow-right"></i></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                <!-- <div class="card booking-schedule schedule-widget"> -->
                                                    <!-- Schedule Content -->
                                                    <div class="schedule-cont">
                                                        <!-- <div class="row">
                                                            <div class="col-md-12"> -->
                                                            
                                                                <!-- Time Slot -->
                                                                <div class="quiz-slot" style="padding:0px">
                                                                    <ul class="clearfix">
                                                                        <li v-for="(data,i) in lstsoal" :key="data.soal.id_soal">
                                                                            <a :class="{'timing': true, 'active' : i === index}" @click.prevent="setRowSoal(i)">
                                                                                <span>{{i+1}}</span>
                                                                            </a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <!-- /Time Slot -->
                                                                
                                                            <!-- </div>
                                                        </div> -->
                                                    </div>
                                                    <!-- /Schedule Content -->
                                                    
                                                <!-- </div> -->
                                            </div>
                                            <div class="card-footer">
                                                
                                                <div class="text-center">
                                                    <router-link to="/siswa/learndoteach" class="btn btn-rounded btn-info">Kembali</router-link> 
                                                </div>
                                            </div>
                                        </div>
                                        <!-- /Booking Summary -->
                                        
                                    </div>
                                </div>
                            <!-- </div> -->
                        </div>
                    </div>

				</div>


			</div>	                          	
			<!-- /Page Content -->
   
			<!-- Footer -->
				<layout-footer />
			<!-- /Footer -->
		   
		</div>
		<!-- /Main Wrapper -->

        <div id="delMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Hapus Soal</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Apakah anda yakin akan menghapus soal nomor <b>{{ idxSoal }}</b></label>
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="hapus">Yakin</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import Sidebar from '../../Sidebar'
import axios from 'axios';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery';

export default {
    components: {
        Sidebar
    },
	name: 'SiswaLeaarnDoTeachSoal',
    data() {
        return {
            ldt: {
                id_paket_sales: '',
                id_paket_jadwal: '',
                nama_paket: '',
                judul_pertemuan: ''
            },
            lstsoal: [],
            index: '', idxSoal: '', soal: '', list_jawaban: '', data: {soal:'', list_jawaban:''},
            defsoal:{
               id_soal: '',
               id_paket_sales:'',
               id_paket_jadwal:'',
               id_user:'',
               uraian_soal:'',
               pembahasan:'',
               jawaban:'A',
               isSave: 0
            },
            deflist_jawaban: [
                {id_jawaban: '', jawaban: 'A', uraian_jawaban: "Opsi A", poin: 5},
                {id_jawaban: '', jawaban: 'B', uraian_jawaban: "Opsi B", poin: 0},
                {id_jawaban: '', jawaban: 'C', uraian_jawaban: "Opsi C", poin: 0},
                {id_jawaban: '', jawaban: 'D', uraian_jawaban: "Opsi D", poin: 0},
                {id_jawaban: '', jawaban: 'E', uraian_jawaban: "Opsi E", poin: 0}
            ],
            myInit: {
                height: 500,
                entity_encoding : 'raw',  
                paste_data_images: true,
                plugins: [
                    'advlist autolink lists link image charmap print preview hr anchor pagebreak',
                    'searchreplace wordcount visualblocks visualchars code fullscreen',
                    'insertdatetime media nonbreaking save table contextmenu directionality',
                    'emoticons template paste textcolor colorpicker textpattern'
                ],
                toolbar1: 'insertfile undo redo | formatselect | fontsizeselect | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
                toolbar2: 'print preview media | forecolor backcolor emoticons tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry',
                external_plugins: {
                    tiny_mce_wiris: 'https://www.wiris.net/demo/plugins/tiny_mce/plugin.js'
                    // 'tiny_mce_wiris': 'node_modules/@wiris/mathtype-tinymce4/plugin.min.js',
                },
                
                // selector: 'textarea',
                // external_plugins: {'mathSymbols': '/your-path-to-plugin/mathsymbols-tinymce-plugin/plugin.min.js'}, // Add plugin to Tinymce
                // toolbar: 'mathSymbols',
                image_advtab: true,
                file_picker_callback: function(callback, value, meta) {
                    if (meta.filetype == 'image') {
                    $('#upload').trigger('click');
                    $('#upload').on('change', function() {
                        var file = this.files[0];
                        var reader = new FileReader();
                        reader.onload = function(e) {
                        callback(e.target.result, {
                            alt: ''
                        });
                        };
                        reader.readAsDataURL(file);
                    });
                    }
                },
                images_upload_handler: function(blobInfo, success, failure) {
                    let formreq = new FormData()
                    // console.log("ini blobnya: ");
                    // console.log(blobInfo.blob());
                    formreq.append('file', blobInfo.blob());
                    var instance = axiosTiny.create({ baseURL: 'https://api.pejuangpendidik.com/' });
                    instance.defaults.headers.post['Content-Type'] = 'multipart/form-data';
                    instance.post('api/uploadimg', formreq,
                        {
                            // headers: {
                            //     'Content-Type': 'multipart/form-data',
                            // },
                            transformRequest: (data, headers) => {
                                return formreq;
                            },
                        }) //this.$route.params.id)
                        .then(res => {
                            // console.log(res.data.location);
                            if(res.status ==200){
                                if(res.data.location !=""){
                                    success(res.data.location);
                                } else {
                                    failure('gagal upload image'+ res.data.location);
                                }
                            } else {
                                failure('gagal upload image'+ res.data.location);
                            }
                        })
                        .catch(err => {
                            // handle error
                            console.log(err);
                        })
                },
                // setup : function(ed) {
                //     ed.on("NodeChange", function(e) {
                        
                //     var selectedNode = tinymce.activeEditor.selection.getNode();
                //         console.log(selectedNode);
                //     if (selectedNode && selectedNode.nodeName == 'IMG') {
                //         var imageSrc = selectedNode.src;
                //         console.log(imageSrc);
                //         console.log('change event', e);
                //     }

                //     })
                // }
                // setup(editor) {
                //     editor.on("keydown", function(e){
                //         console.log("ini kodenya : " +e.keyCode);
                //     if ((e.keyCode == 8 || e.keyCode == 46) && tinymce.activeEditor.selection) {
                //         var selectedNode = tinymce.activeEditor.selection.getNode();
                //         console.log(selectedNode);
                //         if (selectedNode && selectedNode.nodeName == 'IMG') {
                //             var imageSrc = selectedNode.src;
                //             axios.post('api/deluploadimg', 
                //             {
                //                 imgsrc: imageSrc
                //             }) //this.$route.params.id)
                //             .then(res => {
                //                 console.log(res.data);
                //             })
                //             .catch(err => {
                //                 // handle error
                //                 console.log(err);
                //             })
                //         }

                //     }
                //     });
                // } 
                

            },
            myInitJawaban: {
                height: 100,
                menubar:false,
                statusbar: false,
                entity_encoding : 'raw',  
                toolbar: 'tiny_mce_wiris_formulaEditor tiny_mce_wiris_formulaEditorChemistry',
                external_plugins: {
                    tiny_mce_wiris: 'https://www.wiris.net/demo/plugins/tiny_mce/plugin.js'
                    // 'tiny_mce_wiris': 'node_modules/@wiris/mathtype-tinymce4/plugin.min.js',
                },

            }
        }
    },
    created: function () {
        this.soal = this.defsoal; this.list_jawaban = this.deflist_jawaban;
        // console.log(this.$route.params.id);
        this.getLdt();
        this.getSoal();
        // this.getAll();
        // this.getAllMateri();
        // this.getAllSubMateri();
    },  
    // computed: {
    //     classObject: function (idx) {
    //         return {
    //         active: this.soal.active,
    //         'timing': false
    //         }
    //     }
    // },
    methods: {
       
        //--------------------------
        getLdt: function () {
            // console.log("masuk")
            axios.get('api/ldtdetail/'+localStorage.getItem('idUser')+'/'+localStorage.getItem('id_paket_sales')+'/'+localStorage.getItem('id_paket_jadwal'))
                .then(res => {
                    // console.log(res.data);
                    this.ldt = res.data.data;
                    // this.initDt("tblLatihan");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        getSoal: function () {
            axios.get('api/ldtsoal/'+localStorage.getItem('idUser')+'/'+localStorage.getItem('id_paket_sales')+'/'+localStorage.getItem('id_paket_jadwal'))
                .then(res => {
                    // console.log(res);

                    if(res.data.status == 'success'){
                        this.lstsoal = res.data.data;
                        // console.log("ini pjg soal: " + this.lstsoal.length );
                        if(this.lstsoal.length > 0){
                            this.soal.isSave = 1;
                            this.setRowSoal(0);
                        } else {
                            this.addNewSoal();
                        }
                    }
                    // console.log(this.lstsoal[0].soal.pembahasan);
                    // this.initDt("tblLatihan");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        // Set Row Soal
        confirmSaveSoal: function (idx) {            
            swal.fire({  
                title: 'Simpan Soal',
                html: 'Apakah anda ingin menyimpan soal ini?',  
                showDenyButton: true,  showCancelButton: true,  
                confirmButtonText: `Simpan`,  
                denyButtonText: `Tidak`,
            })
            .then((willSave) => {
            if (willSave) {
                this.save();
                this.setRowSoal(idx);
            } else {
                // this.hapus();
                // swal("Your imaginary file is safe!");
                //soal dihapus
            }
            });
        
        },
        
        // Update isSave Soal
        updIsSaveSoal: function () {
            // console.log("isSave before : " + this.soal.isSave);
            this.soal.isSave = 0;
            // console.log("isSave after : " + this.soal.isSave);
        },
            
        // Set Row Soal
        setRowSoal: function (idx) {
            // console.log(this.lstsoal);
            
            if(!this.soal.isSave){
                this.confirmSaveSoal(idx);
            } else {
                // if(idx < 0)
                // idx = 0;
                if(idx >= 0){
                    if(this.lstsoal.length > idx){
                        this.index = idx;
                        this.idxSoal = idx+1;
                        this.soal = this.lstsoal[idx].soal;
                        this.soal.isSave = 1;
                        this.list_jawaban = this.lstsoal[idx].list_jawaban;
                        if(!this.soal.jawaban){
                            this.resetPoin();
                        }
                        // this.lstsoal[index].active = true;
                        // console.log("ini index : " +this.index);
                        // console.log(this.soal);
                    } else {
                        this.addNewSoal();
                    }
                }
            }

        },

        // Add New Soal
        addNewSoal: function () {
            this.soal = this.defsoal; this.list_jawaban = this.deflist_jawaban;
            this.soal.isSave = 1;
            this.save();
            this.data.soal = this.soal; 
            this.data.list_jawaban= this.list_jawaban;
            this.lstsoal.push(this.data);
            this.idxSoal = this.lstsoal.length;
            this.index = this.lstsoal.length-1;
            // console.log(this.idxSoal);
            this.setRowSoal(this.index);
        },
        
        updatePoin() {
            // console.log("jawaban : "+this.soal.jawaban);
            // if(this.soal.jawaban.length == 1){
            //     this.setPoin(jwb, index);
            // }else{
                if(this.soal.jawaban != -1){
                    this.resetPoin();
                    this.soal.jawaban.split('').forEach((jwb,index ) => {
                        this.setPoin(jwb, index);
                    }); 
                    this.updIsSaveSoal();               
                }
            // }

        },

        setPoin(xopsi, idxpoin){
            this.list_jawaban.forEach((opsi,index ) => {
                if(opsi.jawaban == xopsi){
                    var xpoin =0;
                    switch(idxpoin){
                        case 0: xpoin=5; break;
                        case 1: xpoin=4; break;
                        case 2: xpoin=3; break;
                        case 3: xpoin=2; break;
                        case 4: xpoin=1; break;
                    }
                    // console.log("opsi:"+xopsi+" - poin: " + xpoin);
                    opsi.poin = xpoin;
                    this.$set(this.list_jawaban, index, opsi);
                    // console.log("poin updt : " + this.list_jawaban[index].poin);
                }
            });
        },

        resetPoin(){
            this.list_jawaban.forEach((opsi,index ) => {
                opsi.poin = 0;
                this.$set(this.list_jawaban, index, opsi);
            });
        },

        // Create New Soal
        save: function () {
            let poinValues = this.list_jawaban.filter(item => item.poin == '5');
            if(poinValues.length <=0){
                swal.fire("Poin Jawaban benar tidak boleh kosong!", {
                    icon: "danger",
                });
            }
            else if(poinValues.length >1){
                swal.fire("Poin Jawaban benar tidak boleh lebih dari satu!", {
                    icon: "danger",
                });
            }
            else if(!this.soal.jawaban){
                swal.fire("Kunci Jawaban tidak boleh kosong!", {
                    icon: "danger",
                });
            }
            else {
                axios.post('api/ldtsoal', {
                    id_soal: this.soal.id_soal,
                    id_paket_sales: this.ldt.id_paket_sales,
                    id_paket_jadwal: this.ldt.id_paket_jadwal,
                    id_user: localStorage.getItem('idUser'),
                    uraian_soal: this.soal.uraian_soal,
                    pembahasan: this.soal.pembahasan,
                    jawaban: this.soal.jawaban,
                    list_jawaban: this.list_jawaban
                })
                .then(res => {
                    // console.log( res.data.data.list_jawaban);
                    this.soal = res.data.data.soal;
                    this.soal.isSave = 1;
                    this.list_jawaban = res.data.data.list_jawaban;
                    // console.log( this.soal);
                    // console.log( this.list_jawaban);

                  let timerInterval
                    swal.fire({
                    title: 'Simpan Soal',
                    html: 'Soal berhasil disimpan!',
                    timer: 2000,
                    // icon: 'success',
                    timerProgressBar: true,
                    didOpen: () => {
                        swal.showLoading()
                        const b = swal.getHtmlContainer().querySelector('b')
                        timerInterval = setInterval(() => {
                        b.textContent = swal.getTimerLeft()
                        }, 100)
                    },
                    willClose: () => {
                        clearInterval(timerInterval)
                    }
                    }).then((result) => {
                    /* Read more about handling dismissals below */
                    if (result.dismiss === swal.DismissReason.timer) {
                        // console.log('I was closed by the timer')
                    }
                    })

                    // handle success
                    // this.getAll();
                    // this.resetVar();
                    // $("#addMdl").modal('hide');
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
            }
        },

        // Delete Soal
        hapus: function () {

            // if(this.soal.id_soal != ''){
            //     this.$delete(this.lstsoal, this.idxSoal);
            //     this.setRowSoal(this.index);
            // } else {
                axios.post('api/ldtsoaldel', {
                        id_soal: this.soal.id_soal,
                        id_paket_sales: this.ldt.id_paket_sales,
                        id_paket_jadwal: this.ldt.id_paket_jadwal,
                        id_user: localStorage.getItem('idUser')
                    })
                    .then(res => {
                        if(res.data.status == "success"){
                            this.$delete(this.lstsoal, this.index);
                            this.setRowSoal(this.index-1);
                        }
                        $("#delMdl").modal('hide');


                    })
                    .catch(err => {
                        // handle error
                        console.log(err);
                    })
            // }
        },

        // filterSubject: function(value){
        //     this.tryout.id_sub_materi = '';
        //     this.lstsubject = value? this.lstsubmateri.filter(c => c.id_materi == value) : this.lstsubmateri;
        // },

        // resetVar: function(ref,isDasabled=false){
        //     if(ref){                
        //         this.tryout.id_to = ref.id_to;
        //         this.tryout.nama_to = ref.nama_to;
        //         this.tryout.id_materi = ref.id_materi;
        //         this.tryout.id_sub_materi = ref.id_sub_materi;
        //     } else {
        //         this.tryout.id_to = '';
        //         this.tryout.nama_to = '';
        //         this.tryout.id_materi = '';
        //         this.tryout.id_sub_materi = '';
        //     }
            
        //     $("#frm input").prop("disabled", isDasabled);
        //     $("#frm v-select").prop("disabled", isDasabled);
        // },

        // Get Detail and Show data to Modal
        // getDetail: function (ref) {
        //     this.resetVar(ref, true);
        //     $("#addMdl").modal('show');
        // },
 
        // Get Edit and Show data to Modal
        // getEdit: function (ref) {
        //     this.resetVar(ref);
        //     $("#addMdl").modal('show');
        // },

        // Get Delete and Show Confirm Modal
        getDelete: function (ref) {
            this.resetVar(ref);
            $("#delMdl").modal('show');
        },
 
        
        
        //--------------------------
        // Get Materi
        // getAllMateri: function () {
        //     axios.get('api/materi')
        //         .then(res => {
        //             // console.log(res.data);
        //             this.lstmateri = res.data.data;
        //         })
        //         .catch(err => {
        //             // handle error
        //             console.log(err);
        //         })
        // },

        // Get sub_materi
        // getAllSubMateri: function () {
        //     axios.get('api/submateri')
        //         .then(res => {
        //             // console.log(res.data);
        //             this.lstsubmateri = res.data.data;
        //             this.lstsubject = this.lstsubmateri;
        //         })
        //         .catch(err => {
        //             // handle error
        //             console.log(err);
        //         })
        // },
 
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Siswa/LearnDoTeach/Soal/index.vue